export enum SessionStorageKeys {
  insightId = "insightId"
}
